<template>
  <section>
    <div class="sub_cont h100">
      <div class="w85m10">
        <h1 class="mg0">QR 수령인 정보</h1>
        <div class="box_bg mgt40">
          <div class="bg_title">보내는 분 정보</div>
          <dl>
            <dt>보내는 사람</dt>
            <dd>{{ info.sendNm }}</dd>
            <dt>주소</dt>
            <dd>{{ info.sendPostNo }}</dd>
            <dd>{{ info.sendAddr }} {{ info.sendAddrDtl }}</dd>
            <dt>연락처</dt>
            <dd>{{ info.sendTel }}</dd>
          </dl>
        </div>
        <div class="box_bg mgt30">
          <div class="bg_title">받는 분 정보</div>
          <dl>
            <dt>받는 사람</dt>
            <dd>{{ info.receiveNm }}</dd>
            <dt>주소</dt>
            <dd>{{ info.receivePost }}</dd>
            <dd>{{ info.receiveAddr }} {{ info.receiveAddrDtl }}</dd>
            <dt>연락처</dt>
            <dd>{{ info.receiveTel }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import ApiConfig from '@/api/api.config'
import ApiUtil from "@/api/api.util";

const eklDomain = ApiConfig.eklDomain

export default {
  name: "SendRegiLabel",
  mounted() {
    const vm = this
    vm.getSendRegiLabel()
  },
  methods: {
    getSendRegiLabel() {
      const vm = this
      const url = `${eklDomain}/v1/ebmp/ai/manager/kiosk/label/info/${vm.$route.params.sendId}`
      ApiUtil.get(url).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        vm.info = response.data.resultData
        vm.info.sendTel = vm.maskingStr(vm.info.sendTel)
        vm.info.receiveTel = vm.maskingStr(vm.info.receiveTel)
      })
    },
    /**
     * 연락처에 '-'(Hypen) 삽입
     * @param {val} : 연락처
     * @returns {*} : 01012345678 -> 010-1234-5678
     */
    addHypen(val){
      if (val !== undefined && val !== null) {
        val = val.substr(0,13)
        val = val
            .replace(/[^0-9]/g, '')
            .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)
      }
      return val
    },
    /**
     * 핸드폰 번호 마스킹 처리
     * @param str
     * @returns {*|string}
     */
    maskingStr(val) {
      if (val == undefined || val === '') {
        return ''
      }
      let pattern = /.{4}$/
      val = this.addHypen(val)
      return val.replace(pattern, "****")
    }
  },
  data () {
    return  {
      info:{},
    }
  }

}
</script>

<style scoped>
.sub_cont{
  text-align: center;
  display: flex;
  flex-direction: column ;
  height: 90vh;
  box-sizing: border-box;
  justify-content: space-between;
  font-size: 2.5vh;
  letter-spacing:-0.1em ;
}
.h100{
  height: 100vh !important;
}
.w85m10{
  margin: 10% auto;
  width: 85%;
}
.mg0 {
  margin: 0px !important;
}
.box_bg{
  border-radius:1em;
  background: #fff;
  box-shadow: 0 0 30px #00000026;
  margin-top: 13%;
  text-align: left;
  padding: 10%;
  position: relative;
  font-size: 2.1vh;
  overflow: inherit !important;
}
.mgt30 {
  margin-top: 30px !important;
}
.mgt40 {
  margin-top: 40px !important;
}
.bg_title{
  background: #303030;
  color: #fff;
  font-size: 2.3vh;
  display: inline-block;
  padding: 2% 5%;
  border-radius: 5vh;
  top: -3vh;
  position: absolute;
}
dl{
  list-style: none;
  padding: 0;
}
.main h1, .sub_cont h1 {
  font-size: 1.3em;
  margin-top: 5%;
}
h1, h2 {
  font-weight: 700 !important;
  color: #2c2d39;
}
h1 {
  font-size: 25px;
  line-height: 25px;
  letter-spacing: -2px;
  margin-bottom: 0;
}
.box_bg dl dt:first-child {
  margin-top: 3%;
}
.box_bg dl dt {
  font-weight: 700 !important;
  margin-top: 6%;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
textarea,
p,
blockquote,
th,
td,
input,
select,
button {
  margin: 0;
  padding: 0;
  outline: none;
  word-break: normal;
  word-wrap: break-word;
  font-family: "Spoqa Han Sans", "Roboto", "Noto Sans KR", "맑은 고딕",
  "Malgun Gothic", "dotum", sans-serif;
  font-weight: 300;
  line-height: 1.5;
  letter-spacing: -0.8px;
  font-size: 14px;
  color: #333333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
